import { RequestDataReadOnly } from "../request-data-section/request-data-read-only.content";
import { EvaluationSection } from "../evaluation-section.content";
import { InvoiceSection } from "../invoice-section/invoice-section.content";
import type { ExternalProviderDashboardVM } from "@shared-kernel/application/ports/external-provider/external-provider-repository";
import type { UseInvoiceSubmitResult } from "../../hooks/use-invoice-submit";
import type { SubmitEvaluationBody } from "@shared-kernel/application/ports/external-provider/external-provider-repository";
import type { EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS } from "@academy-context/shared/domain/types/enums/external-provider-batch-request";

interface Props {
  data: ExternalProviderDashboardVM;
  currentStatus: EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS;
  invoiceSubmit: UseInvoiceSubmitResult;
  onEvaluationSubmit: (participationId: string, body: SubmitEvaluationBody) => Promise<void>;
}

/**
 * Invoice Editable Phase - Provider can submit/edit invoice and evaluations
 * Shown when status is: WAITING_FOR_INVOICE or INVOICE_REFUSED
 */
export const InvoiceEditablePhase = ({ data, invoiceSubmit, onEvaluationSubmit }: Props) => {
  return (
    <>
      <EvaluationSection
        participationId={data.participation?.id ?? null}
        objectives={data.objectives}
        appraisal={data.appraisal}
        onSubmit={onEvaluationSubmit}
      />
      <InvoiceSection data={data} invoiceSubmit={invoiceSubmit} />
      <RequestDataReadOnly data={data} />
    </>
  );
};
